import React from "react";
import "./ArticleFull.css";

const EntryRulesBrazil = () => {
  return (
    <div className="article-full">
      <h1 className="article-title">
        🛬 Правила въезда в Бразилию для россиян в 2025 году
      </h1>

      <p className="article-text">
        Бразилия остаётся одной из немногих стран, куда россияне могут поехать без визы. Однако перед поездкой важно 
        знать актуальные требования и документы, которые могут понадобиться.
      </p>

      <h3 className="article-section-title">Нужна ли виза?</h3>
      <p className="article-text">
        Гражданам России виза в Бразилию <strong>не требуется</strong> при пребывании до 90 дней. 
        Этот срок можно продлить ещё на 90 дней уже внутри страны, обратившись в Федеральную полицию.
      </p>

      <h3 className="article-section-title">🛂 Какие документы нужны на въезде?</h3>
      <ul className="article-list">
        <li>Загранпаспорт, действительный минимум 6 месяцев с момента въезда</li>
        <li>Билет в оба конца или подтверждение выезда из страны</li>
        <li>Доказательства финансовой состоятельности (наличные, выписки с карты, бронь отеля)</li>
        <li>Рекомендуется: медицинская страховка</li>
      </ul>

      <h3 className="article-section-title">🧾 Нужно ли предъявлять прививку от жёлтой лихорадки?</h3>
      <p className="article-text">
        Для въезда в Бразилию из России <strong>прививка от жёлтой лихорадки не обязательна</strong>. 
        Однако она может потребоваться, если вы путешествуете через другие страны Южной Америки.
      </p>

      <h3 className="article-section-title">📎 Продление пребывания</h3>
      <p className="article-text">
        Продлить пребывание можно на дополнительные 90 дней, но об этом нужно позаботиться заранее — подать заявку минимум за 2 недели 
        до окончания первого срока.
      </p>

      <div className="article-note">
        <p className="article-note-text">
          💡 <strong>Совет:</strong> Всегда проверяй актуальную информацию перед поездкой — правила могут меняться. 
          Уточнить детали можно на сайте консульства Бразилии или у авиакомпании.
        </p>
      </div>
    </div>
  );
};

export default EntryRulesBrazil;